class LinkAddTargetBlank {

  constructor(config = {}) {
    const {
      linkSelector
    } = config;

    this.linkSelector = Array.prototype.slice.call(document.querySelectorAll(linkSelector));
    if (this.linkSelector.length > 0) {
      this.linkSelector.forEach(link => {
        this.addTargetBlank(link);
      });
    }
  }

  addTargetBlank(link) {
    link.setAttribute('target', '_blank');
  }

}

export default LinkAddTargetBlank;
